import {
  OPEN_NEW_PROJECT_MODAL,
  CLOSE_NEW_PROJECT_MODAL,
} from '../actionsTypes/projects';

export const openNewProjectModal = () => ({ type: OPEN_NEW_PROJECT_MODAL });

export const closeNewProjectModal = () => ({ type: CLOSE_NEW_PROJECT_MODAL });
